const initialState = {
  permissionFlags: [],
  createMailTemplatePending: false,
  createMailTemplateError: null,
  createSmsTemplatePending: false,
  createSmsTemplateError: null,
  fetchAllSmsTemplatePending: false,
  fetchAllSmsTemplateError: null,
  fetchAllMailTemplatePending: false,
  fetchAllMailTemplateError: null,
  smsTemplates: [],
  mailTemplates: [],
  tooltipTemplates: [],
  agreementTemplates: [],
  typesenseSearchTemplates: [],
  socketIoTemplates: [],
  fetchTemplatePending: false,
  fetchTemplateError: null,
  template: null,
  updateTemplatePending: false,
  updateTemplateError: null,
  loadCollectionsPending: false,
  loadCollectionsError: null,
  collections: [],
  deleteTemplatePending: false,
  deleteTemplateError: null,
  createTooltipTemplatePending: false,
  createTooltipTemplateError: null,
  fetchAllTooltipTemplatePending: false,
  fetchAllTooltipTemplateError: null,
  getPermissionFlagsPending: false,
  getPermissionFlagsError: null,
  createAgreementTemplatePending: false,
  createAgreementTemplateError: null,
  fetchAllAgreementTemplatePending: false,
  fetchAllAgreementTemplateError: null,
  fetchAllTypesenseSearchTemplatePending: false,
  fetchAllTypesenseSearchTemplateError: null,
  createTypesenseSearchTemplatePending: false,
  createTypesenseSearchTemplateError: null,
  createSocketIoTemplatePending: false,
  createSocketIoTemplateError: null,
  fetchAllSocketIoTemplatePending: false,
  fetchAllSocketIoTemplateError: null,
  generateTemplatePending: false,
  generateTemplateError: null,
};

export default initialState;
